import { useState } from "react";
import { KeyRound, ShieldCheck } from "lucide-react";
import { ApiError, changePin, type SessionUser } from "../lib/api";

export function ChangePin({ user, onComplete }: { user: SessionUser; onComplete: () => void }) {
  const [currentPin, setCurrentPin] = useState("");
  const [newPin, setNewPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (newPin !== confirmPin) return setError("PIN ใหม่ทั้งสองช่องไม่ตรงกัน");
    if (newPin === currentPin) return setError("กรุณาตั้ง PIN ใหม่ที่ไม่ซ้ำกับ PIN ชั่วคราว");
    setSaving(true);
    setError(null);
    try {
      await changePin(currentPin, newPin);
      onComplete();
    } catch (reason) {
      setError(reason instanceof ApiError ? reason.message : "เปลี่ยน PIN ไม่สำเร็จ");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-panel" aria-labelledby="pin-title">
        <span className="setup-icon"><KeyRound size={28} /></span>
        <div className="login-copy"><h1 id="pin-title">ตั้ง PIN ส่วนตัว</h1><p>{user.fullName} · เปลี่ยน PIN ชั่วคราวก่อนเริ่มใช้งาน</p></div>
        <form className="login-form" onSubmit={submit}>
          <PinField label="PIN ชั่วคราว" value={currentPin} onChange={setCurrentPin} autoComplete="current-password" />
          <PinField label="PIN ใหม่ 6 หลัก" value={newPin} onChange={setNewPin} autoComplete="new-password" />
          <PinField label="ยืนยัน PIN ใหม่" value={confirmPin} onChange={setConfirmPin} autoComplete="new-password" />
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="button primary large" disabled={saving || currentPin.length !== 6 || newPin.length !== 6 || confirmPin.length !== 6}><ShieldCheck size={20} />{saving ? "กำลังบันทึก…" : "บันทึก PIN และเริ่มใช้งาน"}</button>
        </form>
      </section>
    </main>
  );
}

function PinField({ label, value, onChange, autoComplete }: { label: string; value: string; onChange: (value: string) => void; autoComplete: string }) {
  return <label>{label}<input type="password" inputMode="numeric" pattern="[0-9]{6}" maxLength={6} autoComplete={autoComplete} value={value} onChange={(event) => onChange(event.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="••••••" required /></label>;
}
